export const OFFER_LOADING = 'waitrose/offer/LOADING';
export const OFFER_LOADED = 'waitrose/offer/LOADED';
export const OFFER_FAILED = 'waitrose/offer/FAILED';
export const TOGGLE_OFFER_EDITING = 'waitrose/offer/TOGGLE_OFFER_EDITING';
